import * as React from "react";
const SvgFiRrTrainSubwayTunnel = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-train-subway-tunnel_svg__a)">
      <path
        fill="#062147"
        d="M15 6H9c-2.757 0-5 2.243-5 5v6a4.01 4.01 0 0 0 3.113 3.901l-.966 1.577a1 1 0 1 0 1.705 1.044L9.397 21h5.205l1.545 2.522a.999.999 0 1 0 1.705-1.044l-.966-1.577A4.006 4.006 0 0 0 19.999 17v-6c0-2.757-2.243-5-5-5zm3 5v2h-5V8h2c1.654 0 3 1.346 3 3M9 8h2v5H6v-2c0-1.654 1.346-3 3-3m7 11H8c-1.103 0-2-.897-2-2v-2h2v1a1 1 0 1 0 2 0v-1h4v1a1 1 0 1 0 2 0v-1h2v2c0 1.103-.897 2-2 2m8-7v11a1 1 0 1 1-2 0V12c0-5.514-4.486-10-10-10S2 6.486 2 12v11a1 1 0 1 1-2 0V12C0 5.383 5.383 0 12 0s12 5.383 12 12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-train-subway-tunnel_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTrainSubwayTunnel;
